const MODULE_NAME = 'PHYSICIAN_CHECK';
const PHYSICIAN_CHECK_STARTED = MODULE_NAME + 'STARTED';
const PHYSICIAN_CHECK_COMPLETED = MODULE_NAME + 'COMPLETED';

export {
  PHYSICIAN_CHECK_STARTED, PHYSICIAN_CHECK_COMPLETED
};
